export default __webpack_public_path__ + "static/media/conqueror.00b989ba.png";